<template>
  <div class="loader-container" v-if="loading">
    <span class="loader" />
  </div>
</template>
<script>
export default {
  props: {
    loading: {
      type: Boolean,
      required: true
    }
  }
}
</script>
<style lang="scss" scoped>
  @import "~styles/utils.scss";
  .loader {
    font-size: 5rem;
    margin: 2rem auto;
  }
  .loader-container {
    padding-bottom: 1rem;
  }
</style>
